import React, { Component } from 'react'
import { Grid, Menu, Segment } from 'semantic-ui-react'
import AdminPanelContent from './AdminPanelContent';

export default class MenuExampleTabularOnLeft extends Component {
  state = { activeItem: 'admin' }

  handleItemClick = (e: any, {name} : any) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state

    return (
      <Grid>
        <Grid.Column width={4}>
          <Menu fluid vertical tabular>
            <Menu.Item
              name='admin'
              active={activeItem === 'admin'}
              onClick={this.handleItemClick}
            />
            <Menu.Item
              name='add'
              active={activeItem === 'add'}
              onClick={this.handleItemClick}
            />
            <Menu.Item
              name='update'
              active={activeItem === 'update'}
              onClick={this.handleItemClick}
            />
            <Menu.Item
              name='delete'
              active={activeItem === 'delete'}
              onClick={this.handleItemClick}
            />
          </Menu>
        </Grid.Column>

        <Grid.Column stretched width={12}>
          <Segment>
            { AdminPanelContent(activeItem)}
          </Segment>
            
        </Grid.Column>
      </Grid>
    )
  }
}